import './ResidencePlan.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import { useState } from 'react'

const ResidencePlan = () => {

  const [index, setIndex] = useState(0);

  const plans = [
    { type: '1 BED APARTMENT', beds: 1, bathrooms: 1, KITCHENETTE: 1, lounge: 1, image: './ParkPhotos/ResidencePlan/1bed-02.jpg' },
    { type: '2 BED APARTMENT', beds: 2, bathrooms: 2, KITCHENETTE: 1, lounge: 1, image: './ParkPhotos/ResidencePlan/2bed-02.jpg' },
        { type: '3 BED APARTMENT', beds: 3, bathrooms: 3, KITCHENETTE: 1, lounge: 1, image: './ParkPhotos/ResidencePlan/3bed-03.jpeg' },
    // { type: 'PENTHOUSE', beds: 3, bathrooms: 3, KITCHENETTE: 1, lounge: 1, image: './DowntownPhotos/ResidencePlan/penthouse.jpg' },
  ]
  const handleLeftArrowClick = () => {
    if (index < plans.length - 1) {
      setIndex(index + 1);
    }
  };

  const handleRightArrowClick = () => {
    if (index > 0) {
      setIndex(index - 1);
    }
  };


  return (
    <div>
      <div className="residence">
        <div className="resi">
          <div className='residenceplan' data-aos="fade-up"
            data-aos-duration="1000">
            <div className='residenceplan-heading'>
              <h3>Residence Plan</h3>
            </div>
            <div className='residenceplan-card'>
              <div className='residenceplan-card-left'>
                <div className='residenceplan-card-left-top'>
                  <h4>{plans[index].type}</h4>
                  <div>
                    <button onClick={handleRightArrowClick} disabled={index === 0} >
                      <FontAwesomeIcon icon={faArrowLeft} className='residenceplan-card-left-top-arrows' />
                    </button>
                    <button onClick={handleLeftArrowClick} disabled={index === plans.length - 1}>
                      <FontAwesomeIcon icon={faArrowRight} className='residenceplan-card-left-top-arrows' />
                    </button>
                  </div>
                </div>
                <div className='residenceplan-card-left-mid'>
                  <div className='residenceplan-card-left-mid-content'>
                    <p>BEDROOM </p>
                    <p>{plans[index].beds}</p>
                  </div>
                  <div className='residenceplan-card-left-mid-content'>
                    <p>bathrooms</p>
                    <p>{plans[index].bathrooms}</p>
                  </div>
                  <div className='residenceplan-card-left-mid-content'>
                    <p>KITCHENETTE</p>
                    <p>{plans[index].KITCHENETTE}</p>
                  </div>
                  <div className='residenceplan-card-left-mid-content'>
                    <p>LOUNGE</p>
                    <p>{plans[index].lounge}</p>
                  </div>
                </div>
                <div className='residenceplan-card-left-bottom'>
                  <p>
                    We take pride in offering luxurious living spaces where you can truly unwind and enjoy your time.
                  </p>
                </div>
              </div>
              <div className='residenceplan-img'>
                <img src={plans[index].image} alt={plans[index].type} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ResidencePlan